import { SimpleModel } from 'model/SimpleModel';

import { DistributionChannel } from './DistributionChannel';
import { Logic } from './Logic';
import { LogicType } from './LogicType';

export namespace LogicDistribution {
  export interface Shape extends Logic.Shape {
    channel: DistributionChannel;
  }
}

export class LogicDistribution extends Logic<LogicDistribution.Shape> {
  constructor(initialData: SimpleModel.Data<LogicDistribution.Shape>) {
    super(initialData, LogicType.Distribution);
  }

  getChannel(): DistributionChannel {
    return this.get('channel');
  }

  hasChannel(): boolean {
    return this.get('channel') !== undefined;
  }
}
